import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const loginByTelegram = (data: {
  visitorId: string
  language?: ILanguage['locale']
  initData: string
}): AxiosPromise => apiFetch(`/telegram-auth/login`, { data, method: `POST` })

export default loginByTelegram
